export var MerchantCategory;
(function (MerchantCategory) {
    MerchantCategory["GROCERY"] = "grocery";
    MerchantCategory["BAKERY"] = "bakery";
    MerchantCategory["PACKED_FOOD"] = "packed_food";
    MerchantCategory["FRESH_FOOD"] = "fresh_food";
})(MerchantCategory || (MerchantCategory = {}));
export var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["INCOMPLETE"] = "incomplete";
    VerificationStatus["PENDING"] = "pending";
    VerificationStatus["VERIFIED"] = "verified";
    VerificationStatus["REJECTED"] = "rejected";
})(VerificationStatus || (VerificationStatus = {}));
//# sourceMappingURL=merchant.model.js.map